import {
    Box, TableContainer, Table, TableHead,
    TableRow, TableCell, TableBody, Grid
} from "@mui/material";
import SelectionBox from './selectionBox';
import Badge from './badge';
import { useEffect, useState, useCallback } from "react";
import CustomButton from 'components/Common/Button';
import { PRIMARY_BUTTON, DISABLED_BUTTON } from 'themes/theme';
import { fetchLegalInfo, saveLegalInfo, fetchStateContactInfo } from 'store/actions/correctYourDataActions';
import { useSelector, useDispatch } from 'react-redux';
import findLabel from './findLabel';
import Snackbar from "components/Common/SnackBar";
import ThreeDotsLoadingSpinner from 'components/Common/LoadingSpinner/threeDots';
import moment from 'moment';
import findTooltipContent from "./findTooltipContent";
import eventBus from "../../utils/eventBus"
import SecretaryState from "./SecretaryState";
import ZendeskLink from 'components/Common/ZendeskLink'

const sx = {
  buttonPlacement: {
    marginTop: '30px',
    display: 'flex',
    justifyContent: 'end',
  },
}

const LegalInformation = ({ onDataChange }) => {
  const dispatch = useDispatch()
  const claimedBusiness = useSelector(state => state.apiResponseReducers.dashboardInfo.business_list)
  const legalInfo = useSelector(state => state.correctYourDataReducer.legalInformation)
  const stateContactInfo = useSelector(state => state.correctYourDataReducer.stateContactInfo)
  const [saveDisable, setDisable] = useState(true)
  const [snackData, setSnackData] = useState({
    isOpen: false,
    type: 'success',
    message: '',
  })
  useEffect(() => {
    fetchLegalInfo(dispatch, claimedBusiness[0].mkz_business_id)
    fetchStateContactInfo(dispatch, claimedBusiness[0].mkz_business_id)
  }, [dispatch, claimedBusiness])

  const handleDataChange = data => {
    onDataChange(true)
    setDisable(false)
    const updatedData = legalInfo.map(row => {
      if (row.label === data.label) {
        return data
      } else {
        return row
      }
    })
    dispatch({
      type: 'UPDATELEGALINFO',
      payload: updatedData,
    })
  }

  const saveCallback = data => {
    setSnackData(data)
    setDisable(true)
  }

  const saveLegalInformation = useCallback(() => {
    const data = {
      businessId: claimedBusiness[0].mkz_business_id,
      legalInfo,
    }
    setDisable(true)
    saveLegalInfo(dispatch, data, res => saveCallback(res))
    onDataChange(false)
  }, [claimedBusiness, dispatch, legalInfo, onDataChange])

  useEffect(() => {
    eventBus.on('cyd-tab-change', saveLegalInformation)
    return function () {
      eventBus.off('cyd-tab-change', saveLegalInformation)
    }
  }, [saveLegalInformation])

  return (
    <>
      {legalInfo.length ? (
        <Box>
          <Grid container>
            <SecretaryState stateContactInfo={stateContactInfo} tab="legal" />
            <Grid item xs={1.5} sx={sx.buttonPlacement}>
              <Box>
                <CustomButton onClick={saveLegalInformation} type={saveDisable ? DISABLED_BUTTON : PRIMARY_BUTTON}>
                  Update
                </CustomButton>
              </Box>
            </Grid>
          </Grid>
          <Box className="markaazCards">
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>EXISTING INFORMATION</TableCell>
                    <TableCell align="center">
                      <Box color="#00B596">Correct</Box>
                    </TableCell>
                    <TableCell align="center">
                      <Box color="#D14343">Incorrect</Box>
                    </TableCell>
                    <TableCell align="left">UPDATED INFORMATION</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {legalInfo.map(val => {
                    return (
                      <TableRow
                        key={val.label}
                        sx={{
                          'td, th': { border: 0 },
                          background: val.isCorrect === true ? '#F6FCFA' : val.isCorrect === false ? '#FDF6F6' : '#fff',
                        }}
                      >
                        <TableCell component="th" scope="row">
                          <Box>
                            <Box color="#0A78CD" fontSize="12px" fontWeight={400}>
                              {findLabel(val.label)}
                            </Box>
                            <Box
                              marginTop="5px"
                              fontSize="16px"
                              fontWeight={400}
                              color={val.publicInformation ? '#66668F' : '#BDBDCE'}
                            >
                              {val.publicInformation ? val.publicInformation : 'No data found'}
                            </Box>
                          </Box>
                        </TableCell>
                        <SelectionBox
                          TooltipContent={findTooltipContent(val.label)}
                          data={val}
                          onDataChange={changedData => handleDataChange(changedData)}
                        />
                        <TableCell align="center">
                          {val.isCorrect !== null && <Badge type={val.isCorrect === true ? 'success' : 'error'} />}
                        </TableCell>
                        <TableCell align="left">
                          {val.updatedOn && (
                            <Box>
                              Updated on <br />
                              {moment(val.updatedOn).format('MM/DD/YYYY')}
                            </Box>
                          )}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <ZendeskLink />
          {snackData.isOpen && <Snackbar isOpen={true} type={snackData.type} message={snackData.message} />}
        </Box>
      ) : (
        <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
          <ThreeDotsLoadingSpinner width="60px" />
        </Box>
      )}
    </>
  )
}

export default LegalInformation;